import { IBanner } from '../../../interfaces/Banner.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

export interface getBannersParams {
  searchParam: {
    category: 'CAROUSEL_MAIN' | 'CAROUSEL_SUB';
    outputLocation: 'home' | 'open-market' | 'tractor-poking' | 'new-product';
  };
}

export const getBanners = ({ searchParam }: getBannersParams): Promise<IBanner[]> => {
  const URLSearchParams = createURLSearchParams(searchParam);

  return customAxios.get(`/banners?${URLSearchParams}`);
};
